import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { ModuleComponent } from "../module.component";
import { GuideService } from "../../services/guide.service";
import { ScrollToService } from "ng2-scroll-to-el";
import { IdentityService } from "../../../services/identity.service";
import { ToastrService } from "ngx-toastr";


@Component({
  templateUrl: "./1A.component.html",
  styleUrls: ["../component.css"]
})
export class _1AComponent extends ModuleComponent {

  cisUrl: string;
  constructor(router: Router, guideService: GuideService, modalService: BsModalService, scrollService: ScrollToService, identitySrv: IdentityService, toastr: ToastrService) {
    super(router, scrollService, guideService, modalService, identitySrv, toastr);

    this.titles.push({
      "activityId": "A11",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> about Career and Interest Surveys`
    });
    this.titles.push({
      "activityId": "A12",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Complete</strong> the Career Cluster Inventory`
    });

    this.titles.push({
      "activityId": "A21",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> about different ways to explore careers`
    });
    this.titles.push({
      "activityId": "A22",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Explore</strong> careers`
    });

    this.titles.push({
      "activityId": "A31",
      "html": `<i class="fas fa-file-import"></i> <strong>Learn</strong> about the following when ranking your career options`
    });
    this.titles.push({
      "activityId": "A32",
      "html": `<i class="fas fa-mouse-pointer"></i> <strong>Rank</strong> your bookmarked careers to show your top three choices.`
    });

    this.titles.push({
      "activityId": "A41",
      "html": `Test your knowledge of what you learned. These questions will be on the post-assessment test.`
    });


    this.group = 0;
    this.alpha = "A";

    this.activeMod = { group: 0, alpha: "A", number: 1 };

    if (window.innerWidth <= 768)
      this.smallScreen = true;
  }

  ngOnInit() {
    this.loadCisUrl();
  }

  ngAfterViewInit() {

    this.loadGuide();    

  }

  loadCisUrl() {

    this.guideService.GetCisUrl().subscribe(res => {


      this.cisUrl = res;

    });

  }
}
